import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectSchemaValue } from '../../services/schemas/selectors';

interface Props {
    name?: string;
}

export class SchemaName extends React.PureComponent<Props> {
    render() {
        return this.props.name || null;
    }
}

const mapStateToProps = createStructuredSelector({
    name: makeSelectSchemaValue('name')
});

export default connect(mapStateToProps)(SchemaName);
